import React from "react";
import { Icon } from "../icons";
import { fmtDateTime } from "../lib/format";
import { useMcOps } from "../lib/McOpsContext";
import { StatCard } from "../components/Common";

export const MgmtSummaryPage = () => {
  const { state } = useMcOps();

  const total = state.jobs.length;
  const confirmed = state.jobs.filter((j) => j.confirmCallDone).length;
  const resolvedEsc = state.escalations.filter((e) => e.status === "resolved").length;
  const openEsc = state.escalations.filter((e) => e.status === "open").length;
  const count = (channel) =>
    state.notifExternal.filter((n) => n.channel === channel).length;
  const missed = count("missed-call");
  const outboundCalls = count("outbound-call");
  const inboundCalls = count("inbound-call");
  const textsSent = count("text");
  const emailsSent = count("email");
  const unattended = state.notifExternal.filter((n) => n.unattended).length;
  const totalCallAttempts = missed + outboundCalls;

  const introDurs = state.jobs
    .filter((j) => j.introCallDone)
    .map((j) => j.introCallDurationMin)
    .filter((v) => v != null);
  const avgIntro = introDurs.length
    ? Math.round(introDurs.reduce((a, b) => a + b, 0) / introDurs.length)
    : null;
  const confirmDurs = state.jobs
    .filter((j) => j.confirmCallDone)
    .map((j) => j.confirmCallDurationMin)
    .filter((v) => v != null);
  const avgConfirm = confirmDurs.length
    ? Math.round(confirmDurs.reduce((a, b) => a + b, 0) / confirmDurs.length)
    : null;

  const stats = [
    ["check", "green", "Confirmed job ratio", total ? Math.round((confirmed / total) * 100) + "%" : "—"],
    ["check", "blue", "# mitigated escalations", resolvedEsc],
    ["alert", "red", "Open escalations", openEsc],
    ["phone", "amber", "Missed call %", totalCallAttempts ? Math.round((missed / totalCallAttempts) * 100) + "%" : "—"],
    ["mail", "purple", "Unanswered bucket", unattended],
    ["clipboard", "blue", "Total tracked jobs", total],
    ["clock", "amber", "Avg intro call duration", avgIntro != null ? avgIntro + " min" : "—"],
    ["clock", "amber", "Avg confirmation call duration", avgConfirm != null ? avgConfirm + " min" : "—"],
    ["msg", "blue", "Texts sent", textsSent],
    ["mail", "purple", "Emails sent", emailsSent],
    ["phone", "green", "Outbound calls", outboundCalls],
    ["phone", "blue", "Inbound calls", inboundCalls],
  ];

  const events = [];
  state.notifInternal.forEach((n) =>
    events.push({ date: n.date, label: n.text, tag: n.type, ic: "note" }),
  );
  state.notifExternal.forEach((n) =>
    events.push({ date: n.date, label: n.text, tag: n.channel, ic: "mail" }),
  );
  state.escalations.forEach((e) =>
    events.push({
      date: e.createdAt,
      label: e.type + " escalation: " + e.note,
      tag: e.status,
      ic: "alert",
    }),
  );
  state.jobs.forEach((j) =>
    (j.notes || []).forEach((n) =>
      events.push({
        date: n.date,
        label: j.zohoId + " — " + n.text,
        tag: "note",
        ic: "clipboard",
      }),
    ),
  );
  events.sort((a, b) => new Date(b.date) - new Date(a.date));
  const top = events.slice(0, 12);

  return (
    <div className="page active">
      <div className="page-title-row">
        <div>
          <h2 className="page-title">Backend / Management Summary</h2>
          <div className="page-desc">
            Timeline tracking across all screens, call durations, and contact-volume
            metrics. The unanswered bucket is visible dashboard-wide — MCs rotate
            daily to cover it.
          </div>
        </div>
      </div>

      <div className="mgmt-grid">
        {stats.map(([ic, color, label, num]) => (
          <StatCard icon={ic} color={color} num={num} label={label} key={label} />
        ))}
      </div>

      <div className="panel-head" style={{ border: "none", padding: "0 0 10px 0" }}>
        Timeline — Recent Activity Across All Screens
      </div>
      <div className="panel">
        <div className="panel-body" style={{ maxHeight: 320 }}>
          {top.length ? (
            top.map((e, i) => (
              <div className="list-item" key={i}>
                <div
                  className="li-icon"
                  style={{ background: "var(--ink-100)", color: "var(--ink-500)" }}
                >
                  <Icon name={e.ic} />
                </div>
                <div className="li-body">
                  <span className="badge plain">{e.tag}</span> {e.label}
                  <div className="meta">{fmtDateTime(e.date)}</div>
                </div>
              </div>
            ))
          ) : (
            <div className="panel-empty">No activity yet.</div>
          )}
        </div>
      </div>
    </div>
  );
};
